/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_ButtonInputs */

const en_audio_description_export_button = /** @type {(inputs: Audio_Description_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Audio`)
};

const fr_audio_description_export_button = /** @type {(inputs: Audio_Description_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter l'audio`)
};

const de_audio_description_export_button = /** @type {(inputs: Audio_Description_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio exportieren`)
};

const it_audio_description_export_button = /** @type {(inputs: Audio_Description_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta audio`)
};

const ru_audio_description_export_button = /** @type {(inputs: Audio_Description_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт аудио`)
};

const es_audio_description_export_button = /** @type {(inputs: Audio_Description_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar audio`)
};

const zh_cn2_audio_description_export_button = /** @type {(inputs: Audio_Description_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出音频`)
};

const ja_audio_description_export_button = /** @type {(inputs: Audio_Description_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオをエクスポート`)
};

const hi_audio_description_export_button = /** @type {(inputs: Audio_Description_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो निर्यात करें`)
};

const pt_pt2_audio_description_export_button = /** @type {(inputs: Audio_Description_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar áudio`)
};

/**
* | output |
* | --- |
* | "Export Audio" |
*
* @param {Audio_Description_Export_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_button = /** @type {((inputs?: Audio_Description_Export_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_button(inputs)
	if (locale === "de") return de_audio_description_export_button(inputs)
	if (locale === "it") return it_audio_description_export_button(inputs)
	if (locale === "ru") return ru_audio_description_export_button(inputs)
	if (locale === "es") return es_audio_description_export_button(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_button(inputs)
	if (locale === "ja") return ja_audio_description_export_button(inputs)
	if (locale === "hi") return hi_audio_description_export_button(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_button(inputs)
	return en_audio_description_export_button(inputs)
});